import { useState } from 'react';
import { Box, Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useCRUD from 'src/hooks/useCRUD';
import { formatCurrency } from 'src/lib/util/currency-utils';

import { Table } from '../Molecules';

const InvoicesList = ({ customerId, onPaymentRegister, onViewHistory, userId }) => {
  const navigate = useNavigate();
  const { data, loading } = useCRUD(`${process.env.REACT_APP_API_URL}/property/${customerId}/user/${userId}/invoices`);
  const [paidFilter, setPaidFilter] = useState('unpaid');

  console.log('InvoicesList props:', { customerId, onPaymentRegister: !!onPaymentRegister, onViewHistory: !!onViewHistory, userId });
  console.log('data', data);

  const { t } = useTranslation('user', { keyPrefix: 'invoices' });

  const columns = [
    { field: 'invoiceId', text: t('fields.invoiceId') },
    { field: 'billingPeriod', text: t('fields.billingPeriod') },
    { field: 'amountDue', text: t('fields.amountDue') },
    { field: 'amountPaid', text: t('fields.amountPaid') },
    {
      field: 'actions',
      render: invoice => {
        console.log('Rendering actions for invoice:', {
          invoiceId: invoice.invoiceId,
          onPaymentRegister: !!onPaymentRegister,
          onViewHistory: !!onViewHistory,
          paid: invoice.paid
        });
        return (
          <Box sx={{ display: 'flex', gap: 1 }}>
            {!invoice.paid && (
              <Button onClick={() => onPaymentRegister && onPaymentRegister(invoice.invoiceId)} size="small" variant="contained">
                {t('actions.registerPayment', 'Register Payment')}
              </Button>
            )}
            <Button onClick={() => onViewHistory && onViewHistory(invoice.invoiceId)} size="small" variant="outlined">
              {t('actions.viewHistory', 'View History')}
            </Button>
          </Box>
        );
      },
      text: t('fields.actions', 'Actions')
    }
  ];

  const handleOpen = invoiceId => {
    navigate(`/invoice/${invoiceId}`, { state: { connectedAccountNumber: data?.accountNumber } });
  };

  const rows = data?.invoices
    ?.filter(invoice => {
      if (paidFilter === 'paid') return invoice.paid === true;
      if (paidFilter === 'unpaid') return invoice.paid === false;
      return true;
    })
    ?.map(invoice => {
      return {
        amountDue: formatCurrency(invoice.amountDue),
        amountPaid: formatCurrency(invoice.amountPaid),
        billingPeriod: invoice.billingPeriod,
        id: invoice.invoiceId,
        invoiceId: invoice.invoiceId,
        paid: invoice.paid
      };
    });

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <FormControl size="small" sx={{ minWidth: 200 }} variant="outlined">
          <InputLabel>{t('filters.paymentStatus')}</InputLabel>
          <Select label={t('filters.paymentStatus')} onChange={e => setPaidFilter(e.target.value)} value={paidFilter}>
            <MenuItem value="paid">{t('filters.paid')}</MenuItem>
            <MenuItem value="unpaid">{t('filters.unpaid')}</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Table columns={columns} loading={loading || !rows} onEdit={null} onView={handleOpen} rows={rows} />
    </Box>
  );
};

export default InvoicesList;
